import React from 'react';

/**
 * Card — white surface with subtle shadow. Optional header (icon + title +
 * description) rendered above the body.
 */
export const Card = ({ icon: Icon, title, description, headerActions, children, className = '', testId }) => {
  const hasHeader = Icon || title || description || headerActions;
  return (
    <section className={`kr-card ${className}`} data-testid={testId}>
      {hasHeader && (
        <header className="kr-card-header">
          {Icon && (
            <div className="kr-card-icon">
              <Icon size={20} />
            </div>
          )}
          <div className="flex-1 min-w-0">
            {title && <h2 className="kr-card-title">{title}</h2>}
            {description && <p className="kr-card-desc">{description}</p>}
          </div>
          {headerActions && <div className="flex items-center gap-2">{headerActions}</div>}
        </header>
      )}
      <div className="kr-card-body">{children}</div>
    </section>
  );
};

export default Card;
